import { getCurrentUser } from '@/api/user/getCurrentUser.ts';
import { updateUserPreferences } from '@/api/user/updateUserPreferences.ts';
import { webapi } from '@/api/webapi.ts';
import type { AppState } from '@/store/store.ts';

export const userApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    currentUser: getCurrentUser(builder),
    updateUserPreferences: updateUserPreferences(builder),
  }),
});

export const { useCurrentUserQuery, useUpdateUserPreferencesMutation } = userApi;

const { select: selectCurrentUser } = userApi.endpoints.currentUser;
export const selectGetCurrentUser = (state: AppState) => selectCurrentUser()(state);
